import { ShoppingCartIcon } from "@heroicons/react/24/solid";
import SpinnerLoading from "@/components/ui/loading/SpinnerLoading";

interface AddToCartBtnProps {
  disabled: boolean;
  isLoading: boolean;
  isPurchasable: boolean;
  handleClick: () => void;
}

const AddToCartBtn = ({ handleClick, disabled, isLoading, isPurchasable }: AddToCartBtnProps) => {
  return (
    <button
      onClick={handleClick}
      type="button"
      disabled={disabled}
      className="brand-btn-base btn btn-primary w-full disabled:bg-opacity-100 disabled:text-opacity-100 lg:w-fit"
    >
      {isLoading ? (
        <SpinnerLoading />
      ) : isPurchasable ? (
        <>
          <ShoppingCartIcon className="box-content size-5" />
          加入購物車
        </>
      ) : (
        "已售完"
      )}
    </button>
  );
};

export default AddToCartBtn;
